module.exports = "<div class=\"document-shell\">\r\n    <article class=\"document\" role=\"contentinfo\">\r\n        <div class=\"document-closer\" role=\"button\" aria-label=\"Close document\" title=\"Close document\">\r\n            <i class=\"fa fa-remove\" aria-hidden=\"true\"></i>\r\n        </div>\r\n        <div class=\"document-loading\"></div>\r\n        <div data-document-ids=\"\" class=\"document-mask\"></div>\r\n        <div class=\"document-content\" role=\"document\"></div>\r\n    </article>\r\n    <div class=\"precedent-map-preview\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/desktop/views/document-holder.html
// module id = 340
// module chunks = 1